import { render, staticRenderFns } from "./activity-edit.vue?vue&type=template&id=6f27079e&scoped=true"
import script from "./activity-edit.vue?vue&type=script&lang=js"
export * from "./activity-edit.vue?vue&type=script&lang=js"
import style0 from "./activity-edit.vue?vue&type=style&index=0&id=6f27079e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f27079e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f27079e')) {
      api.createRecord('6f27079e', component.options)
    } else {
      api.reload('6f27079e', component.options)
    }
    module.hot.accept("./activity-edit.vue?vue&type=template&id=6f27079e&scoped=true", function () {
      api.rerender('6f27079e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/components/activity-edit.vue"
export default component.exports